// removed by extract-text-webpack-plugin
module.exports = {"content":"_8TAnM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageContent/PageContent.scss
// module id = ./src/components/Page/PageContent/PageContent.scss
// module chunks = 5